import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Entities',
  content: `
In Pliable's semantic layer, entities represent key business concepts, such as Customers, Orders, or Ad Campaigns. They are the building blocks of your data model, reflecting the real-world objects or processes that drive your business operations. By defining entities, you provide a clear and structured way to organize data, enabling a shared understanding across teams. Entities also serve as the foundation for defining relationships and metrics, ensuring that insights are accurate and meaningful within the context of your business.

# Creating an Entity

To create a new Entity, navigate to the **Semantic Layer** and use the form to quickly add a new Entity. The newly created Entity will appear in your diagram, and from there you can connect it to other Entities and Metrics.

# Entity Columns

Columns define the attributes or properties of an entity, functioning as a detailed data catalog. For example, a Customer entity might have columns like Name, Email, and Signup Date, while an Order entity could include Order ID, Amount, and Date. These columns provide granular visibility into the data associated with each entity, ensuring clarity and precision in how the business concepts are represented and used across the data model.

## Dimensions

Using the label icon, you can optionally indicate that you would like to use a column as a **dimension**. Dimensions represent descriptive attributes of an entity, such as the Region for a Customer or the Category for a Product. Flagging a column as a dimension in Pliable allows it to be used for grouping, slicing, and dicing data in Pliable's report builder.

## Data Types

Entity columns have data types, which indicate the type of data you expect to be in those columns.

The data type of a column controls which aggregation methods you can use in your Metrics. For example, if you have a column that is type **TEXT**, the available aggregation methods for any connected Metric will be "Count Distinct", "Random", and "Concatenate". However, if you have a column that is type **INTEGER** or **DECIMAL**, you will be able to select numerical aggregations such as SUM, MIN, MAX, and AVG in connected metrics.

Oftentimes your source data will not be formatted correctly to be automatically converted to a specific data type. In that case, you will want to clean it before it gets mapped to an Entity. Read more about [column cleaning](/docs/column-formatting).

### Available Data Types

| Data Type | Description |
|-----------|-------------|
| TEXT | Free-form text values |
| INTEGER | Whole numbers |
| DECIMAL | Numbers with decimal places |
| DATE | Date values |
| DATETIME | Date and time values |
| BOOLEAN | True/false values |
`,
};

export default doc;
